import { Component } from '@angular/core';

@Component({
    template: `<app-spinner></app-spinner>`,
    styles: []
})
export class HoldingPageComponent {

}